<script setup lang="ts">
import { Link } from "@inertiajs/vue3"
import {
  Baby,
  FileText,
  GraduationCap,
  HeartPulse,
  Laptop,
  Layout,
  Settings,
  ShoppingBag,
  TowerControl,
  UsersRound,
} from "lucide-vue-next"

import NavFooter from "@/components/NavFooter.vue"
import NavMain from "@/components/NavMain.vue"
import NavUser from "@/components/NavUser.vue"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  managerAppSettingsPath,
  managerDashboardAutoPath,
  managerDashboardPath,
  managerEmployeeManagementPath,
  managerEmployeesPath,
  managerInsurancesPath,
  managerMarketplacePath,
  managerMumsAndDadsPath,
  managerStudiesPath,
  managerTeleworksPath,
} from "@/routes"
import { type NavItem } from "@/types"

import AppLogo from "./AppLogo.vue"

const mainNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: managerDashboardPath(),
    icon: Layout,
  },
  {
    title: "Reportes Autogestión",
    href: managerDashboardAutoPath(),
    icon: FileText,
  },
  {
    title: "Ayuda de Estudios",
    href: managerStudiesPath(),
    icon: GraduationCap,
  },
  {
    title: "Seguro de Salud",
    href: managerInsurancesPath(),
    icon: HeartPulse,
  },
  {
    title: "Ayuda de Teletrabajo",
    href: managerTeleworksPath(),
    icon: Laptop,
  },
  {
    title: "Pago de guardería",
    href: managerMumsAndDadsPath(),
    icon: Baby,
  },
  {
    title: "Marketplace",
    href: managerMarketplacePath(),
    icon: ShoppingBag,
  },
  {
    title: "Reporte Global",
    href: managerEmployeeManagementPath(),
    icon: TowerControl,
  },
  {
    title: "Perfiles de Empleados",
    href: managerEmployeesPath(),
    icon: UsersRound,
  },
]

const footerNavItems: NavItem[] = [
  {
    title: "Configura tu App",
    href: managerAppSettingsPath(),
    icon: Settings,
  },
]
</script>

<template>
  <Sidebar collapsible="icon" variant="inset">
    <SidebarHeader>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton size="lg" as-child>
            <Link :href="managerDashboardPath()">
              <AppLogo />
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>

    <SidebarContent>
      <NavMain :items="mainNavItems" />
    </SidebarContent>

    <SidebarFooter>
      <NavFooter :items="footerNavItems" />
      <NavUser />
    </SidebarFooter>
  </Sidebar>
  <slot />
</template>
